<mat-chip-set>
	<mat-chip class="status-chip" [ngClass]="getChipStyling(status)" [attr.data-automation-id]="'chip-' + status"
		>&bull;&NonBreakingSpace;{{ getStatusName(status) }}</mat-chip
	>
</mat-chip-set>
